import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import TableFoot from './TableFoot/TableFoot';
import TableRow from './TableRow/TableRow';
import { getImageProduct } from '../utils';
import { getIdFromGid, isGid } from '../../utils';

const DetailsTable = styled.table.attrs({
  className: 'bundle-details-table',
})`
  width: 100%;
  th,
  tr,
  td {
    border: none;
    text-align: left;
    padding: 8px 0px 8px 0px;
  }
  td:first-child {
    padding-left: 0px;
  }
  td:last-child {
    padding-right: 0px;
    min-width: 60px;
  }
  th {
    color: #637381;
    font-size: 16px;
    font-weight: 400;
  }

  tfoot {
    tr:first-child td {
      padding-top: 20px;
    }
    border-top: 1px solid #dfe3e8;
  }

  tr:last-child td {
    padding-bottom: 20px;
  }
`;

const TotalTableHeader = styled.th.attrs({
  className: 'bundleapp-sm-hidden',
})`
  text-align: right;
`;

const ProductsTable = ({
  images,
  sellingPlans,
  subscription,
  shuffleLineData,
  handleUpdateProduct,
  handleUpdateVariant,
  handleRemoveClick,
  handleSkipClick,
  handleUnskipClick,
  handleUpdateBundle,
  swapProductForBundle,
  handleOnQuantityChange,
  babProductVariants,
  isLoadingShippingRate,
  isSkippingShuffleProduct,
  shopConfiguration,
  disableCurrencySensitiveActions = false,
}) => {
  const { t } = useTranslation();

  return (
    <DetailsTable>
      <thead className="bundle-table__header">
        <tr>
          <th>{t('tables.item')}</th>
          <th className="bundleapp-sm-hidden">{t('tables.quantity')}</th>
          {!subscription.ContainsGift && <th>{t('tables.price')}</th>}
          {!subscription.ContainsGift && (
            <TotalTableHeader>{t('tables.total')}</TotalTableHeader>
          )}
          <td></td>
        </tr>
      </thead>
      <tbody className="bundle-table__body">
        {subscription.Lines?.map((line) => {
          const image = getImageProduct({
            productId: isGid(line.ProductId)
              ? getIdFromGid(line.ProductId)
              : line.ProductId,
            variantId: isGid(line.VariantId)
              ? getIdFromGid(line.VariantId)
              : line.VariantId,
            images,
          });

          if (line.HideLine) return null;

          return (
            <TableRow
              key={line.SubscriptionContractLineId}
              line={line}
              image={image}
              shuffleData={shuffleLineData[line.SubscriptionContractLineId]}
              sellingPlans={sellingPlans}
              subscription={subscription}
              handleUpdateProduct={handleUpdateProduct}
              handleUpdateVariant={handleUpdateVariant}
              handleRemoveClick={handleRemoveClick}
              handleSkipClick={handleSkipClick}
              handleUnskipClick={handleUnskipClick}
              handleUpdateBundle={handleUpdateBundle}
              swapProductForBundle={swapProductForBundle}
              handleOnQuantityChange={handleOnQuantityChange}
              babProductVariants={babProductVariants}
              shopConfiguration={shopConfiguration}
              disableCurrencySensitiveActions={disableCurrencySensitiveActions}
              disableSkipShuffleProduct={isSkippingShuffleProduct}
            />
          );
        })}
      </tbody>

      <TableFoot
        subscription={subscription as Subscription}
        isLoadingShippingRate={isLoadingShippingRate}
      />
    </DetailsTable>
  );
};

export default ProductsTable;
